module.exports = __webpack_public_path__ + "img/liaojie.a3675ecc.png";